import { render, staticRenderFns } from "./FollowUpTemplateAdd.vue?vue&type=template&id=24ae7526&"
import script from "./FollowUpTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./FollowUpTemplateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports